import { api, type ApiResponse } from '../client';
import apiClient from '../client';

export interface Charity {
  uuid: string;
  name: string;
  abn?: string;
}

class CharitiesSearchService {
  private baseUrl = '/charity';

  /**
   * Search charities by phrase (name, ABN, etc.)
   * @param phrase Search query
   * @param limit Maximum number of results to return
   * @returns Promise with list of matching charities
   */
  async searchCharities(phrase: string = '', limit: number = 10): Promise<Array<{uuid: string, name: string}>> {
    try {
      // Require phrase to be at least 2 characters
      if (!phrase || phrase.trim().length < 2) {
        return [];
      }
      
      const params = new URLSearchParams();
      params.append('phrase', phrase.trim());
      params.append('per_page', limit.toString());
      params.append('page', '1');

      const axiosResponse = await apiClient.get(`${this.baseUrl}?${params.toString()}`);
      
      const serverResponse = axiosResponse.data;
      
      if (serverResponse && serverResponse.success && serverResponse.data && Array.isArray(serverResponse.data)) {
        return serverResponse.data.map((charity: Charity) => ({
          uuid: charity.uuid,
          name: charity.name
        }));
      }
      
      return [];
    } catch (error: any) {
      console.error('Error searching charities:', error);
      return [];
    }
  }

  /**
   * Get charity by UUID (for getting selected label)
   * @param uuid Charity UUID
   * @returns Promise with charity name or null
   */
  async getCharityName(uuid: string): Promise<string | null> {
    try {
      const response = await api.get<{success: boolean, data: Charity}>(`${this.baseUrl}/${uuid}`);
      
      if (response.data.success && response.data.data) {
        return response.data.data.name;
      }
      
      return null;
    } catch (error: any) {
      console.error('Error getting charity name:', error);
      return null;
    }
  }
}

export const charitiesSearchService = new CharitiesSearchService();
export default charitiesSearchService;

